import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

if (!sessionStorage.getItem('appStarted')) {
  localStorage.clear();
  sessionStorage.setItem('appStarted', 'true');
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
